import React from "react";
import Props from "./Props";

const CenterComponent:React.FC<Props> = ({children}) => {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        {children}
    </div>
}

export default CenterComponent;